const TEXTODETALHES = [
  {
    valor: "supplementation:consumption-closure",
    descricao:
      "supplementation:consumption-closing-description",
    style: { maxWidth: "600px" },
  },
  {
    valor: "supplementation:total-consumption",
    descricao: "supplementation:total-consumption-description",
  },
  {
    valor: "supplementation:actual-consumption",
    descricao: "supplementation:actual-consumption-description",
  },
  {
    valor: "supplementation:target-consumption",
    descricao:
      "supplementation:target-consumption-description",
  },
  {
    valor: "supplementation:daily-count",
    descricao:
      "supplementation:daily-count-description",
  },
];

export {
  TEXTODETALHES
};
